import React from "react";
import "../../assets/css/Services.css"

const Banner = () => {
    return (
        <>
            <div className="bg-white banner_bottom_hammad position-relative py-5 border-top border-top-2 border-black w-100">
                <div className="text_hammad d-flex flex-lg-row flex-sm-column flex-column align-items-start gap-lg-5 gap-xs-2 px-4">
                    <p className="text-uppercase text-black fs-lg-4 fs-xs-5 m-0">[ next project ]</p>
                    <h2 className="text-uppercase text-black font-project display-1 p-0">New Project</h2>
                </div>
                <div className="banner_top_hammad position-absolute left-0 top-0 px-4 text-light border-bottom border-bottom-2 border-black w-100">
                    <h2 style={{ "--pos": 1 }}
                        className="text-uppercase position-absolute text-nowrap  display-1 p-0">
                        New Project
                    </h2>
                    <h2 style={{ "--pos": 2 }}
                        className="text-uppercase text-nowrap display-1  p-0 position-absolute">
                        New Project
                    </h2>
                    <h2 style={{ "--pos": 3 }}
                        className="text-uppercase text-nowrap display-1  p-0 position-absolute">
                        New Project
                    </h2>
                    <h2 style={{ "--pos": 4 }}
                        className="text-uppercase text-nowrap display-1  p-0 position-absolute">
                        New Project
                    </h2>
                </div>
            </div>

        </>
    )

}
export default Banner;